import React, { createContext, useContext, useState } from 'react';
export const DataContext = createContext({});

export const DataContextProvider = props => {
    const dataContext = {
        company: {
            logoUrl: '',
            awards: [],
        },
        configVars: {
            configUrl: '',
            startDate: '',
            endDate: '',
            viewOptions: [],
            displayHeader: true,
            displayTime: 5000,
            displayMode: '',
            companyId: '',
            includeGroup: false,
        },
        startupsPageVars: {
            mostContractedCommunities: [],
            contractsWithStartupsTotal: 0,
            contractsWithStartupsChartData: [],
            contractedStartupsChartData: [],
            contractedStartupsTotal: 0,
            totalContractsAmount: {},
            latestContractedStartups: [],
            startDate: new Date(),
            endDate: new Date(),
        },

        challengesPageVars: {
            speedDatingMeetingsTotals: 0,
            preparedSpeedDatingByDate: [],
            challengesTotals: 0,
            challengesChartData: [],
            startupsAppliedTotal: 0,
            latestChallenges: [],
            oiweeksMeetings: 0,
            latestApplicationStartups: [],
        },

        relationshipsPageVars: {
            bubbleChartData: [],
            geoChartData: [],
        },

        executivesPageVars: {
            startupsMatchedTotal: 0,
            startupsMatchedChartData: [],
            executivesRegistered: 0,
            executivesCertified: 0,
            cxiRanking: [],
        },

        groupsPageVars: {
            groupNetwork: {
                nodes: [],
                nodeLinks: [],
            },
            hireTheMost: [],
            mostHiredStartupsByGroup: [],
        },
    };
    const [company, setCompany] = useState({ ...dataContext?.company });
    const [configVars, setConfigVars] = useState({ ...dataContext?.configVars });
    const [headerVars, setHeaderVars] = useState({ ...dataContext?.headerVars });
    const [startupsPageVars, setStartupsPageVars] = useState({ ...dataContext?.startupsPageVars });
    const [challengesPageVars, setChallengesPageVars] = useState({
        ...dataContext?.challengesPageVars,
    });
    const [relationshipsPageVars, setRelationshipsPageVars] = useState({
        ...dataContext?.relationshipsPageVars,
    });
    const [executivesPageVars, setExecutivesPageVars] = useState({
        ...dataContext?.executivesPageVars,
    });
    const [groupsPageVars, setGroupsPageVars] = useState({ ...dataContext?.groupsPageVars });
    return (
        <DataContext.Provider
            value={{
                state: {
                    company,
                    configVars,
                    headerVars,
                    startupsPageVars,
                    challengesPageVars,
                    relationshipsPageVars,
                    executivesPageVars,
                    groupsPageVars,
                },
                mutations: {
                    setCompany,
                    setConfigVars,
                    setHeaderVars,
                    setStartupsPageVars,
                    setChallengesPageVars,
                    setRelationshipsPageVars,
                    setExecutivesPageVars,
                    setGroupsPageVars,
                },
            }}
        >
            {props.children}
        </DataContext.Provider>
    );
};

export const useData = () => useContext(DataContext);
